module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "w-full  header"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "topcontent"
  }, [_c('div', [_vm._v("欢迎莅临广东元正招标采购有限公司")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("设为首页")]), _vm._v(" | "), _c('span', [_vm._v("加入收藏")]), _c('span', [_vm._v(" | "), _c('span', {
    on: {
      "click": _vm.returnIndex
    }
  }, [_vm._v("返回首页")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "w-inner",
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "warnmsg",
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('version-reminder')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "base-bai",
    attrs: {
      "flex": "cross:center"
    }
  }, [_c('div', {
    staticClass: "w-inner",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('div', {
    on: {
      "click": _vm.toIndex
    }
  }, [(_vm.headlogo) ? _c('div', {
    staticStyle: {
      "float": "left",
      "width": "380px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "cursor": "pointer"
    },
    attrs: {
      "src": _vm.headlogo
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "color": "#1d1d1d",
      "font-size": "16px"
    }
  }, _vm._l((_vm.operMtIdList), function(item, index) {
    return _c('div', {
      staticClass: "selected",
      class: {
        active: +_vm.firstActiveTab === +item.opermtid
      },
      staticStyle: {
        "margin-left": "10px",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.change(index, item)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.opermtname) + "\n      ")])
  }), 0)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-06320b74!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/web/WebHeader.vue
// module id = 292
// module chunks = 0